import { useState } from "react";
import satpalPhoto from "../../static/images/satpalReadal.png";

export function SatpalSection() {
  const [expanded, setExpanded] = useState(false);

  function toggle() {
    setExpanded((open) => {
      if (open) {
        document.getElementById("about")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      return !open;
    });
  }

  return (
    <section id="about">
      <style>{`
        #about {
          position: relative;
          z-index: 3;
          padding: 120px 0;
          background: var(--navy);
          scroll-margin-top: 88px;
        }
        .rs-about-wrap {
          display: grid;
          grid-template-columns: minmax(0, 0.85fr) minmax(0, 1.15fr);
          gap: clamp(32px, 5vw, 72px);
          align-items: start;
        }
        .rs-about-photo {
          margin: 0;
        }
        .rs-about-photo img {
          display: block;
          width: 100%;
          aspect-ratio: 1;
          object-fit: cover;
          object-position: 50% 18%;
          border-radius: 20px;
          border: 1px solid #1D3145;
          background: #0E1623;
        }
        .rs-about-copy h2 {
          font-size: clamp(32px, 4vw, 48px);
          margin: 0 0 10px;
        }
        .rs-about-copy .rs-about-role {
          font-family: "JetBrains Mono", monospace;
          font-size: 13px;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #49D6FF;
          margin: 0 0 28px;
          padding-bottom: 18px;
          border-bottom: 1px solid #1D3145;
        }
        .rs-about-copy p {
          color: #A7B3C2;
          max-width: 62ch;
          margin: 0 0 1em;
        }
        .rs-about-copy h3 {
          font-size: clamp(22px, 2.4vw, 28px);
          margin: 32px 0 16px;
          color: #FFFFFF;
        }
        .rs-about-copy strong {
          color: #F8FAFC;
          font-weight: 600;
        }
        .rs-about-line {
          font-family: "Space Grotesk", sans-serif;
          font-weight: 700;
          font-size: clamp(20px, 2.2vw, 26px);
          line-height: 1.25;
          letter-spacing: -0.02em;
          color: #FFFFFF;
          margin: 32px 0 16px;
          padding-left: 16px;
          border-left: 3px solid #1DA1F2;
        }
        .rs-about-more {
          display: grid;
          grid-template-rows: 0fr;
          opacity: 0;
          transition: grid-template-rows 0.45s cubic-bezier(.16,1,.3,1), opacity 0.3s ease;
        }
        .rs-about-more.is-open {
          grid-template-rows: 1fr;
          opacity: 1;
        }
        .rs-about-more-inner {
          overflow: hidden;
          min-height: 0;
        }
        .rs-about-toggle {
          margin-top: 8px;
          background: none;
          border: none;
          padding: 0;
          font: inherit;
          font-weight: 600;
          font-size: 15px;
          color: #49D6FF;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .rs-about-toggle:hover {
          color: #8CEBFF;
        }
        .rs-about-toggle::after {
          content: "";
          width: 7px;
          height: 7px;
          border-right: 1.6px solid currentColor;
          border-bottom: 1.6px solid currentColor;
          transform: rotate(45deg);
          transition: transform 0.25s ease;
        }
        .rs-about-toggle.is-open::after {
          transform: rotate(-135deg);
          margin-top: 4px;
        }
        @media (max-width: 820px) {
          .rs-about-wrap { grid-template-columns: 1fr; }
          .rs-about-photo { max-width: 420px; }
        }
      `}</style>
      <div className="container">
        <div className="rs-about-wrap reveal">
          <figure className="rs-about-photo">
            <img
              src={satpalPhoto}
              alt="Satpal Thakur, Technology and Business Strategy"
            />
          </figure>
          <div className="rs-about-copy">
            <div className="eyebrow">Leadership</div>
            <h2>Satpal Thakur</h2>
            <p className="rs-about-role">Technology &amp; Business Strategy</p>
            <p>
              Satpal Thakur is a technology professional and entrepreneur focused
              on building businesses through technology, automation, and modern
              digital systems.
            </p>
            <p>
              With experience across ERP, software development, AI automation,
              CRM, cloud solutions, and digital platforms, he brings a
              technology-driven approach to Thakur Constructions—helping
              modernise business operations, project coordination, customer
              experience, and long-term growth.
            </p>
            <p>
              Alongside Thakur Constructions, Satpal leads Readal Systems, a
              technology venture focused on developing practical digital
              solutions for businesses.
            </p>

            <div className={`rs-about-more${expanded ? " is-open" : ""}`}>
              <div className="rs-about-more-inner" id="satpal-bio" aria-hidden={!expanded}>
                <h3>About Satpal Thakur</h3>
                <p>
                  Satpal Thakur works at the intersection of{" "}
                  <strong>
                    technology, entrepreneurship, and business transformation
                  </strong>
                  .
                </p>
                <p>
                  His professional background spans enterprise software, ERP
                  systems, full-stack development, cloud infrastructure, CRM
                  platforms, workflow automation, and AI-powered business
                  solutions. Through Readal Systems, he works on building and
                  implementing technology that helps organisations simplify
                  operations, connect their systems, and work more efficiently.
                </p>
                <p>
                  At Thakur Constructions, Satpal brings that same
                  systems-oriented mindset into the construction business.
                </p>
                <p>
                  His focus is on developing the digital and operational
                  infrastructure behind the company—from project and customer
                  management to automation, documentation, business development,
                  online presence, and technology-enabled project visibility.
                </p>
                <p>
                  He believes the construction industry has significant potential
                  to benefit from better technology. Clearer communication,
                  structured project tracking, digital documentation, transparent
                  processes, and smarter business systems can improve the
                  experience for both construction teams and their clients.
                </p>
                <p>
                  By combining the traditional foundations of construction—
                  <strong>workmanship, responsibility, and trust</strong>—with
                  modern technology and organised operations, Satpal&apos;s
                  objective is to help build Thakur Constructions into a modern
                  and scalable construction company.
                </p>
                <p className="rs-about-line">
                  Building Businesses. Connecting Technology. Creating for the
                  Long Term.
                </p>
                <p>
                  For Satpal, Thakur Constructions and Readal Systems represent
                  two different industries connected by the same principle:{" "}
                  <strong>
                    build something useful, build it properly, and build it to
                    last.
                  </strong>
                </p>
              </div>
            </div>

            <button
              className={`rs-about-toggle${expanded ? " is-open" : ""}`}
              type="button"
              aria-expanded={expanded}
              aria-controls="satpal-bio"
              onClick={toggle}
            >
              {expanded ? "Read less" : "Read more"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
